import { TableName } from "../../../../tables"
import { Emitter, Event } from "../../../event-emitter"
import { ModalId, showErrorStrToast, useUIActions } from "../../../ui"
import { useRemoveHooks } from "../../hooks/removeHooks"

export const useActions = () => {
    const { canRemove, remove, archive } = useRemoveHooks()

    const { openModal, closeModal } = useUIActions()

    const removeDataType = async (
        table: TableName,
        id: string
    ) => {
        Emitter.emit(Event.DB_REMOVE)

        const canRemoveDataType = await canRemove(table, id)
        
        if (canRemoveDataType) {
            await remove(table, id)
            Emitter.emit(Event.DB_REMOVE_DONE)
        } else {
            closeModal(ModalId.SPINNER)
            setTimeout(() => openModal(ModalId.ARCHIVE), 500)
        }
    }

    const archiveDataType = async (
        table: TableName,
        id: string
    ) => {
        try {
            Emitter.emit(Event.DB_ARCHIVE)
            await archive(table, id)
            Emitter.emit(Event.DB_ARCHIVE_DONE)
        } catch (error) {
            closeModal(ModalId.SPINNER)
            showErrorStrToast(error instanceof Error ? error.message : 'No se pudo archivar el registro.')
        }
    }
    
    return {
        removeDataType,
        archiveDataType
    }
}
